import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { buyerLandingPages } from '@/data/buyerLandingPages';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-900 text-white py-12" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

          {/* אודות */}
          <div>
            <h3 className="text-xl font-bold mb-4">Printeam</h3>
            <p className="text-sm text-gray-400 leading-relaxed mb-2">
              Printeam מציעה מיתוג, הדפסה והתאמה אישית של מוצרי טקסטיל ומוצרים
              ממותגים לעסקים, ארגונים ואירועים. באתר ניתן לבחור מוצר, צבע, מידה
              ואזורי מיתוג בהתאם לאפשרויות המוצגות בכל דף מוצר.
            </p>
            <p className="text-xs text-gray-500 mb-4">מופעל על ידי א.ז. שירותי מחשוב ולוגיסטיקה</p>
            <p className="text-sm mb-2">
              <Link to="/about" className="text-blue-400 hover:text-blue-300 transition-colors">אודות בית העסק</Link>
            </p>
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Printeam. {t('allRightsReserved')}
            </p>
          </div>

          {/* צור קשר */}
          <div>
            <h4 className="text-lg font-semibold mb-4">צור קשר</h4>
            <div className="text-gray-300 space-y-2 text-sm">
              <p>
                <span className="text-gray-400">טלפון / וואטסאפ: </span>
                <a href="tel:+972503969640" className="hover:text-white transition-colors">050-396-9640</a>
              </p>
              <p>
                <span className="text-gray-400">אימייל: </span>
                <a href="mailto:info@printeam.co.il" className="hover:text-white transition-colors">info@printeam.co.il</a>
              </p>
              <p>
                <span className="text-gray-400">כתובת: </span>
                האורגים 32, חולון
              </p>
              <p className="pt-1">
                <Link to="/contact" className="text-blue-400 hover:text-blue-300 transition-colors">דף צור קשר ←</Link>
              </p>
            </div>
          </div>

          {/* תקנון ומדיניות */}
          <div>
            <h4 className="text-lg font-semibold mb-4">תקנון ומדיניות</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/terms" className="hover:text-white transition-colors">תנאי שימוש</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition-colors">אודות בית העסק</Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors">מדיניות פרטיות</Link>
              </li>
              <li>
                <Link to="/returns" className="hover:text-white transition-colors">מדיניות ביטולים והחזרות</Link>
              </li>
              <li>
                <Link to="/accessibility" className="hover:text-white transition-colors">הצהרת נגישות</Link>
              </li>
            </ul>
          </div>

          {/* מדיניות משלוחים ואחריות */}
          <div>
            <h4 className="text-lg font-semibold mb-4">משלוחים ואחריות</h4>
            <div className="text-sm text-gray-400 space-y-3">
              <div>
                <p className="text-gray-200 font-medium mb-1">זמני אספקה</p>
                <p>5–10 ימי עבודה ממועד אישור ההזמנה והגשת הקבצים. זמנים עשויים להשתנות בעונות עמוסות.</p>
              </div>
              <div>
                <p className="text-gray-200 font-medium mb-1">אחריות על המוצרים</p>
                <p>במקרה של פגם בייצור או טעות שמקורה בעסק, יש ליצור קשר תוך 7 ימים מקבלת המוצר ולצרף תיעוד ומספר הזמנה.</p>
              </div>
            </div>
          </div>

        </div>
        <nav aria-label="ביגוד לפי סוג ההזמנה" className="mt-10 flex flex-wrap items-center gap-x-7 gap-y-3 border-t border-gray-700 pt-7 text-sm">
          <span className="text-gray-400">בוחרים לפי ההזמנה שלכם</span>
          {buyerLandingPages.map((landing) => (
            <Link key={landing.key} to={landing.path} className="inline-flex min-h-[44px] items-center rounded-sm text-gray-200 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-4 focus-visible:ring-offset-gray-900">
              {landing.navLabel}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
